import styled from 'styled-components';
import { Box } from '../Box/Box';
import { WrapperProps } from '../Wrapper/Wrapper';
import { BorderProps, ColorProps } from '../../../theme/styledProps';

export interface DotProps
  extends WrapperProps,
    Pick<BorderProps, 'borderColor'>,
    Pick<ColorProps, 'bg'> {
  /**
   * Size (px) of the Dot (defaults to 12px)
   */
  size?: number;
}

/**
 * Renders a circular box. Useful for legends, status indicators, etc.
 */
export const Dot = styled(Box)<DotProps>(({ size = 12, borderColor }) => ({
  width: size,
  height: size,
  borderRadius: size / 2,
  borderStyle: borderColor ? 'solid' : 'none',
  borderWidth: borderColor ? 1 : 0,
  flexShrink: 0,
}));
